async function $09ed0efea94ceeb1$export$68a801b7b3c0bfaa() {
    const url = "https://dummyjson.com/products?limit=0";
    const res = await fetch(url);
    const productsData = await res.json();
    return productsData.products;
}
async function $09ed0efea94ceeb1$export$4a5d6423d159594b(searchQuery) {
    const url = `https://dummyjson.com/products/search?q=${searchQuery}`;
    console.log(url);
    const res = await fetch(url);
    const productsData = await res.json();
    return productsData.products;
}
async function $09ed0efea94ceeb1$export$8e670c9304341543(price) {
    console.log("price and brand filter");
    console.log(price);
    // console.log(brand);
    // const url = `https://dummyjson.com/products/?limit=0&select=${brand},${price}`;
    const url = `https://dummyjson.com/products/?limit=0&select=apple`;
    console.log(url);
    const res = await fetch(url);
    const productsData = await res.json();
    return productsData.products;
}
async function $09ed0efea94ceeb1$export$ecade9e04bcee947(category) {
    console.log(category);
    const url = `https://dummyjson.com/products/category/${category}`;
    console.log(url);
    const res = await fetch(url);
    const productsData = await res.json();
    return productsData.products;
}
async function $09ed0efea94ceeb1$export$5688a49ba9fa6755(productId) {
    const url = `https://dummyjson.com/products/${productId}`;
    console.log(url);
    const res = await fetch(url);
    const productsData = await res.json();
    return productsData.products;
}



// import { getProducts } from "./modules/fetchFunctions.js";
const $b8f0d7ab97dededd$var$productsContainer = document.querySelector("#productContainer");
function $b8f0d7ab97dededd$export$701310ed366ede44(products) {
    for (const product of products)$b8f0d7ab97dededd$var$createProductCard(product, $b8f0d7ab97dededd$var$productsContainer);
}
function $b8f0d7ab97dededd$var$createProductCard({ id: id, title: title, thumbnail: thumbnail, description: description, price: price, stock: stock, rating: rating, brand: brand, category: category }, productsContainer) {
    const productCard = document.createElement("article");
    const div1 = document.createElement("div");
    const div2 = document.createElement("div");
    const productTitle = document.createElement("h2");
    const productDescription = document.createElement("p");
    const productThumbnail = document.createElement("img");
    const productPrice = document.createElement("p");
    const productStock = document.createElement("p");
    const productRating = document.createElement("p");
    const pBrand = document.createElement("p");
    const pCategory = document.createElement("p");
    const buyButton = document.createElement("button");
    productCard.classList.add("productCard");
    productCard.setAttribute("id", id);
    productPrice.classList.add("productPrice");
    pBrand.classList.add("brand");
    pCategory.classList.add("categoryHeader");
    buyButton.classList.add("buyButton");
    pCategory.setAttribute("id", category);
    productTitle.innerText = title;
    productThumbnail.src = thumbnail;
    productDescription.innerText = description;
    productRating.innerText = "Rating: " + rating;
    pBrand.innerText = brand;
    pCategory.innerText = category;
    pCategory.addEventListener("click", (event)=>{
        event.preventDefault();
        $b8f0d7ab97dededd$export$3bda3cbcfb67f7e2();
        const category = event.target.id;
        (0, $09ed0efea94ceeb1$export$ecade9e04bcee947)(category).then($b8f0d7ab97dededd$export$701310ed366ede44);
    });
    productPrice.innerText = price + " $";
    productStock.innerText = "In stock: " + stock;
    if (stock < 10) {
        productStock.classList.add("warning");
        productStock.innerText = `Warning only ${stock} left in stock!`;
    }
    buyButton.innerText = "Buy product";
    if (category === "smartphones") productCard.classList.add("categoryMobile");
    else if (category === "laptops") productCard.classList.add("categoryLaptops");
    else if (category === "skincare") productCard.classList.add("categorySkincare");
    else if (category === "fragrances") productCard.classList.add("categoryFragrances");
    else if (category === "groceries") productCard.classList.add("categoryGroceries");
    else if (category === "home-decoration" || category === "furniture") productCard.classList.add("categoryHome");
    else if (category === "tops" || category === "womens-dresses" || category === "womens-shoes" || category === "mens-watches" || category === "mens-shoes" || category === "mens-shirts") productCard.classList.add("categoryClothing");
    productCard.append(div1, div2);
    div1.append(productTitle, productThumbnail, productDescription, productRating, pBrand, productPrice, pCategory);
    div2.append(productStock, buyButton);
    productsContainer.append(productCard);
}
function $b8f0d7ab97dededd$export$3bda3cbcfb67f7e2() {
    $b8f0d7ab97dededd$var$productsContainer.innerHTML = "";
} /*********************************
  Single product
**********************************/  // const productCard = document.querySelector('.productCard') as HTMLDivElement;
 // productsContainer.addEventListener('click', (event) => {
 //   event.preventDefault();
 //   clearPrevLists();
 //   const productId = ((event.target as HTMLInputElement).id);
 //   console.log(productId);
 //   getSingleProduct(productId)
 //   .then(displayProducts)
 // });


(0, $09ed0efea94ceeb1$export$68a801b7b3c0bfaa)().then((0, $b8f0d7ab97dededd$export$701310ed366ede44));
const $ad2bcec7a0192558$var$form = document.querySelector("#searchForm");
$ad2bcec7a0192558$var$form.addEventListener("submit", (event)=>{
    event.preventDefault();
    (0, $b8f0d7ab97dededd$export$3bda3cbcfb67f7e2)();
    const searchQuery = document.querySelector("#searchQuery").value.trim();
    (0, $09ed0efea94ceeb1$export$4a5d6423d159594b)(searchQuery).then((0, $b8f0d7ab97dededd$export$701310ed366ede44));
    // .catch(displayError);
    $ad2bcec7a0192558$var$form.reset();
});
const $ad2bcec7a0192558$var$categoryMenu = document.querySelector("#categoryBoxes");
$ad2bcec7a0192558$var$categoryMenu.addEventListener("click", (event)=>{
    event.preventDefault();
    (0, $b8f0d7ab97dededd$export$3bda3cbcfb67f7e2)();
    const category = event.target.id;
    (0, $09ed0efea94ceeb1$export$ecade9e04bcee947)(category).then((0, $b8f0d7ab97dededd$export$701310ed366ede44));
}) // const filterForm = document.querySelector('#filterForm') as HTMLFormElement;
 // filterForm.addEventListener('submit', (event) => {
 //   event.preventDefault();
 //   clearPrevLists();
 //   const priceFilterChoice:string = (document.querySelector('#priceFilter') as HTMLInputElement).value;
 //   const brandFilterChoice:string = (document.querySelector('#brandFilter') as HTMLInputElement).value;
 //   // getProductsFilter(priceFilterChoice, brandFilterChoice)
 //   getProductsFilter(priceFilterChoice)
 //     .then(displayProducts)
 //   form.reset();
 // })
;


//# sourceMappingURL=index.01159fb4.js.map
